<template>
  <v-form ref="mainForm" v-model="valid">
    <data-iterator
      :list="sas.equivalencesCours"
      add-new-text="Ajouter un cours"
      :live="{ endpoint: 'sas-equivalence-cours', sasId: sas.id, payload: { codeTypeCours: 'NE' } }"
      card-width="900"
      :icon="$getIcon('cours')"
      :valids="valids"
      ref="dataIterator"
    >
      <template v-slot:show-mode="{ item }">
        <h3 v-if="item.titre">{{ item.titre }}</h3>
        <p class="my-0" v-if="item.sigleOuNumero">{{ item.sigleOuNumero }}</p>
      </template>
      <template v-slot:edit-mode="{ item }">
        <opq-catalogue code="categorie-cours" v-model="item.categorieNeuropsy" :live="liveSasCours(6814, item)"></opq-catalogue>
        <opq-text-field :opq-if="estSituation1ou2" code="sigle-cours" v-model="item.sigleOuNumero" :live="liveSasCours(6802, item)"></opq-text-field>
        <opq-text-field code="titre-cours" v-model="item.titre" :live="liveSasCours(6803, item)"></opq-text-field>
        <opq-text-field
          :opq-if="estSituation2ou3"
          code="universite-cours"
          v-model="item.universite"
          :live="liveSasCours(6808, item)"
        ></opq-text-field>
        <opq-text-field
          :opq-if="estSituation2ou3"
          code="heures-cours"
          v-model="item.nombreDHeures"
          :live="liveSasCours(6806, item)"
          is-number
        ></opq-text-field>
      </template>
    </data-iterator>
  </v-form>
</template>

<script>
import FormHybrid from "@/mixins/FormHybrid"
import CataloguesHelper from "@/mixins/CataloguesHelpers"
export default {
  mixins: [FormHybrid, CataloguesHelper],
  props: {
    sas: { type: Object }
  },

  computed: {
    estSituation1ou2() {
      return this.estSituation(1) || this.estSituation(2)
    },
    estSituation2ou3() {
      return this.estSituation(2) || this.estSituation(3)
    }
  },
  methods: {
    liveSasCours(cle, item) {
      return { endpoint: "sas-equivalence-cours", cle: cle, fileId: item.id }
    },
    estSituation(codeSituation) {
      return this.getCatalogueCodeById(7808, this.sas.sasNeuropsy.situation) == codeSituation
    }
  }
}
</script>

<style>
</style>